module.exports = __webpack_public_path__ + "img/WeChat_accounts-fmaster.a026789d.png";